import { NgModule } from '@angular/core';
import { loginRouting } from '../routing';
import {
  LoginComponent,
  TermsAndConditionsComponent,
  CancelPolicyComponent,
  HeaderComponent,
  BaseComponent,
  SidebarComponent
} from '../../components';
import { SharedModule } from './shared.module';

@NgModule({
  imports: [
    loginRouting,
    SharedModule
  ],
  declarations: [
    LoginComponent,
    HeaderComponent,
    CancelPolicyComponent,
    BaseComponent,
    SidebarComponent,
    TermsAndConditionsComponent
  ],
  exports: [
    LoginComponent,
    CancelPolicyComponent,
    TermsAndConditionsComponent,
    SharedModule
  ]
})
export class LoginModule {
}
